import React, { useMemo } from "react";

import moment from "moment";
import type { TooltipProps as RechartsTooltipProps } from "recharts";

import styles from "./Tooltip.module.css";

interface TooltipProps extends RechartsTooltipProps<number | string, number | string> {
	valueSuffix?: string;
}

export default function Tooltip({ valueSuffix, active, payload, label }: TooltipProps) {
	const title = useMemo(() => {
		if (!label) {
			return null;
		}
		const formattedDate = moment(label);
		return formattedDate.isValid() ? formattedDate.format("ddd, MMM D") : label;
	}, [label]);
	if (!active || payload?.length === 0) {
		return null;
	}
	return (
		<div className={styles.tooltip}>
			{title && <h3>{title}</h3>}
			{payload?.map(({ value, name, color, payload }) => (
				<div key={name}>
					<span style={{ background: color || payload?.fill }} />
					<p>
						<span>
							{value}
							{valueSuffix}
						</span>
						{name}
					</p>
				</div>
			))}
		</div>
	);
}
